import { useEffect, useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import LoadingSpinner from '../../../components/LoadingSpinner';

import { StoreContext } from '../../../components/Store';
import { refreshShipmentStatus } from '../../../api/GBENSDec';

const statuses = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const RefreshStatusModal = ({ headerId, isOpen, setIsOpen, onRefreshData }) => {
  const store = useContext(StoreContext);
  const [status, setStatus] = useState(statuses.LOADING);

  useEffect(() => {
    const refreshStatus = async () => {
      try {
        setStatus(statuses.LOADING);
        await refreshShipmentStatus(headerId);
        setStatus(statuses.SUCCESS);

        if (onRefreshData) {
          onRefreshData();
        }
      } catch (err) {
        setStatus(statuses.ERROR);
        store.showError('Issue refreshing shipment status. ' + err.message);
      }
    };

    if (isOpen) {
      refreshStatus();
    }
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={() => status !== statuses.LOADING && setIsOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 650,
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: 4,
          borderRadius: 5,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Refreshing Shipment Status
        </Typography>

        {status === statuses.ERROR && (
          <Alert severity="error" sx={{ marginTop: 2, marginBottom: 4 }}>
            An error occurred - please try again later.
          </Alert>
        )}

        {status === statuses.SUCCESS && (
          <Alert sx={{ marginTop: 2, marginBottom: 4 }}>Shipment status refreshed successfully.</Alert>
        )}

        {status === statuses.LOADING && <LoadingSpinner />}

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <span></span>
          <Button variant="contained" onClick={() => setIsOpen(false)} disabled={status === statuses.LOADING}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RefreshStatusModal;
